<div class="row bk-white contact-us mb-4">
  <div class="col-lg-6 col-md-6 col-12 section-container">
    <div class="section-contact">
      <p class="title">{{ "contact-us" | translate }}</p>
      <p class="desc">{{ "contact-info" | translate }}</p>
      <div style="margin-top: 10%">
        <div class="d-flex desc" style="align-items: center">
          <img style="width: 50px" src="assets/images/landing/email.svg" />
          <p class="mb-0 mx-2">
            <a
              href="mailto:you@falak.sa"
              style="text-decoration: none; color: inherit; cursor: pointer"
              >{{ "you@falak.sa" }}</a
            >
          </p>
        </div>
        <div class="d-flex mt-4 desc" style="align-items: center">
          <img style="width: 50px" src="assets/images/landing/location.svg" />
          <p class="mb-0 mx-2">{{ "location" | translate }}</p>
        </div>
        <div class="d-flex justify-content-start mt-4 mx-2" style="gap: 2.5rem">
          <a href="https://www.instagram.com/falakhub" target="_blank">
            <img
              class="social"
              style="width: 25px"
              src="assets/images/landing/instagram.svg"
            />
          </a>
          <a href="https://www.linkedin.com/company/falak-hub/" target="_blank">
            <img
              class="social"
              style="width: 25px"
              src="assets/images/landing/linked.svg"
            />
          </a>
          <a href="https://x.com/falak_hub" target="_blank">
            <img
              class="social"
              style="width: 25px"
              src="assets/images/landing/twitter.svg"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-6 col-md-6 col-12 form-container">
    <form>
      <div class="row margin-row">
        <div class="col-lg-6 col-md-6 col-12">
          <div class="form-group">
            <app-evento-input
              [eventoFormControl]="contactUsForm.get('fullName')!"
              minlengthMessage="{{
                'Min Length Field' | translate : { value: '6' }
              }}"
              maxlengthMessage="{{
                'Max Length Field' | translate : { value: '40' }
              }}"
              requiredMessage="{{ 'Required Field' | translate }}"
              placeholder="{{ 'full-name' | translate }}"
              label="{{ 'full-name' | translate }}"
              [requiredQuestionFlag]="true"
              onlyWhitespaceMessage="{{ 'Valid Name' | translate }}"
            >
            </app-evento-input>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-12">
          <div class="form-group">
            <app-evento-input
              [eventoFormControl]="contactUsForm.get('email')!"
              label="{{ 'email' | translate }}"
              requiredMessage="{{ 'Required Field' | translate }}"
              patternMessage="{{ 'Valid Email Address' | translate }}"
              placeholder="{{ 'email' | translate }}"
              [requiredQuestionFlag]="true"
            >
            </app-evento-input>
          </div>
        </div>
      </div>

      <div class="row margin-row">
        <div class="col-lg-6 col-md-6 col-12">
          <div class="form-group">
            <app-evento-input
              [eventoFormControl]="contactUsForm.get('mobile')!"
              type="mobile"
              label="{{ 'Mobile number' | translate }}"
              requiredMessage="{{ 'Required Field' | translate }}"
              validatePhoneNumberMessage="{{
                'Valid Mobile Number' | translate
              }}"
              placeholder="{{ 'Mobile number' | translate }}"
            >
            </app-evento-input>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-12">
          <div style="margin-bottom: 5%">
            <app-evento-input
              [eventoFormControl]="contactUsForm.get('subject')!"
              label="{{ 'message-subject' | translate }}"
              requiredMessage="{{ 'Required Field' | translate }}"
              placeholder="{{ 'message-subject' | translate }}"
              onlyWhitespaceMessage="{{ 'Valid Text' | translate }}"
              [requiredQuestionFlag]="true"
              minlengthMessage="{{
                'Min Length Field' | translate : { value: '6' }
              }}"
              maxlengthMessage="{{
                'Max Length Field' | translate : { value: '40' }
              }}"
            >
            </app-evento-input>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 5%">
        <app-evento-input
          [eventoFormControl]="contactUsForm.get('message')!"
          type="textarea"
          label="{{ 'message' | translate }}"
          requiredMessage="{{ 'Required Field' | translate }}"
          placeholder="{{ 'message' | translate }}"
          [requiredQuestionFlag]="true"
          onlyWhitespaceMessage="{{ 'Valid Text' | translate }}"
          minlengthMessage="{{
            'Min Length Field' | translate : { value: '6' }
          }}"
          maxlengthMessage="{{
            'Max Length Field' | translate : { value: '40' }
          }}"
        >
        </app-evento-input>
      </div>
      <button
        [disabled]="!contactUsForm.valid"
        (click)="submit()"
        type="submit"
        class="btn btn-submit w-100"
      >
        {{ "send" | translate }}
      </button>
    </form>
  </div>
</div>
